import { format, formatDistanceToNow, isValid, parseISO } from 'date-fns';

// ----------------------------------------------------------------------

export function fDate(date) {
  return format(new Date(date), 'dd MMMM yyyy');
}

export function fDateTime(date) {
  return format(new Date(date), 'dd MMM yyyy HH:mm');
}

export function fDateTimeSuffix(date) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm p');
}

export function fDateTimeUnixFormat(date) {
  return format(new Date(date), 'yyyy-MM-dd HH:mm:ss');
}

export function fParseDateTimeUnixFormat(date) {
  if (!date) {
    return null;
  }

  if (isValid(parseISO(date))) {
    return format(new Date(date), 'yyyy-MM-dd HH:mm:ss');
  }

  if (!Number.isNaN(date)) {
    return format(new Date(Number(date)), 'yyyy-MM-dd HH:mm:ss');
  }

  return date;
}
// This will return the ISO date in UTC Time
export function toUTCISOString(date) {
  const offsetInMinutes = date.getTimezoneOffset();

  const utcTime = new Date(date.getTime() + offsetInMinutes * 60000);

  const utcISOString = utcTime.toISOString();

  return utcISOString;
}

export function displayLongformat(dateString) {
  // Convert the date string to a Date object
  const dateObject = new Date(dateString);

  // Create a DateTimeFormat object for "en-AU" locale
  const formatter = new Intl.DateTimeFormat('en-AU', {
    weekday: 'short',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false,
    timeZoneName: 'short'
  });

  // Format the date using the formatter
  const formattedDate = formatter.format(dateObject);

  return formattedDate;
}

export function fToNow(date) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true
  });
}
